import { useModel } from "../../contexts/modelContextNew";
import { IClassNameProps } from "../controlsPropertiesInterface";
import "./dateFieldNew.scss";
import { IPropsFieldModel, IPropsFieldValue, IPropsInputChange, IPropsName } from "./fieldPropertiesInterfaceNew";
import RadioButtonField from "./radioButtonFieldNew";

interface IFieldDefinition {
    key: string;
    value: string;
    icon?: string;
    label?: string;
};

interface IPropsFieldDefinitions {
    fieldDefinitions: Array<IFieldDefinition>
}

type IPropsRadioButtonGroup = (IPropsFieldValue | IPropsFieldModel) & IPropsName & IPropsFieldDefinitions & IPropsInputChange & IClassNameProps;

function RadioButtonGroup({
  model,
  attr,
  name,
  onChange,
  fieldDefinitions,
  className
}: IPropsRadioButtonGroup) {
    const modelContext = useModel();

    return (
        <div className={`btn-group radiobtns ${className}`}>
            {
                fieldDefinitions.map((fieldDefinition) => (
                    <RadioButtonField
                        model={model || modelContext}
                        attr={attr || ''}
                        key={fieldDefinition.key}
                        id={fieldDefinition.key}
                        value={fieldDefinition.value}
                        label={fieldDefinition.label || ''}
                        icon={fieldDefinition.icon || ''}
                        name={name}
                        onChange={onChange}
                    ></RadioButtonField>
                ))
            }
        </div>
    );
}

export default RadioButtonGroup;